import clsx from "clsx";
import { FC, ReactNode, useId } from "react";

/**
 * A term with a dotted underline that explains itself in the global tooltip
 * on hover, tap or keyboard focus, in place of an (i) icon. Screen readers
 * hear the explanation as the term's description.
 */
export const Explainer: FC<{
  tip: string;
  children: ReactNode;
  className?: string;
}> = ({ tip, children, className }) => {
  const id = useId();
  return (
    <>
      <span
        className={clsx("has-tip", className)}
        tabIndex={0}
        aria-describedby={id}
        data-tooltip-id="global-tip"
        data-tooltip-content={tip}
        data-tooltip-class-name="tooltip--explainer">
        {children}
      </span>
      <span id={id} hidden>
        {tip}
      </span>
    </>
  );
};
